module.exports = __webpack_public_path__ + "static/media/tyre-high.0d04a96d.png";